import moment from 'moment'

const CronUtils = {
  splitOrElse: array => {
    if (array) return array.split(',')
    return []
  },
  parse: (cron = '') => {
    const splitted = cron.split(' ')
    return {
      minutes: splitted[0],
      hours: CronUtils.splitOrElse(splitted[1]),
      days: CronUtils.splitOrElse(splitted[2]),
      month: CronUtils.splitOrElse(splitted[3]),
      week: CronUtils.splitOrElse(splitted[4]),
      year: CronUtils.splitOrElse(splitted[5])
    }
  },
  getDefaultYear() {
    return [
      {
        disabled: false,
        checked: false,
        name: 'janvier',
        month: 1
      },
      {
        disabled: false,
        checked: false,
        name: 'fevrier',
        month: 2
      },
      {
        disabled: false,
        checked: false,
        name: 'mars',
        month: 3
      },
      {
        disabled: false,
        checked: false,
        name: 'avril',
        month: 4
      },
      {
        disabled: false,
        checked: false,
        name: 'mai',
        month: 5
      },
      {
        disabled: false,
        checked: false,
        name: 'juin',
        month: 6
      },
      {
        disabled: false,
        checked: false,
        name: 'juillet',
        month: 7
      },
      {
        disabled: false,
        checked: false,
        name: 'aout',
        month: 8
      },
      {
        disabled: false,
        checked: false,
        name: 'septembre',
        month: 9
      },
      {
        disabled: false,
        checked: false,
        name: 'octobre',
        month: 10
      },
      {
        disabled: false,
        checked: false,
        name: 'novembre',
        month: 11
      },
      {
        disabled: false,
        checked: false,
        name: 'décembre',
        month: 12
      }
    ]
  },
  toCron(splittedCron) {
    return [
      splittedCron.minutes || 0,
      splittedCron.hours.join(',') || 0,
      splittedCron.days.join(',') || '*',
      splittedCron.month.join(',') || '*',
      splittedCron.week.join(',') || '*'
    ].join(' ')
  },
  isAllWeek(week) {
    return week.join() === '1,2,3,4,5' || week.join() === '1,2,3,4,5,6' || week.join() === '1,2,3,4,5,6,7'
  },
  stringWeekLength(week) {
    // Tous les jours sauf samedi et dimanche = 9
    // Tous les jours  sauf dimanche = 11
    // Tous les jours = 13
    if (week.join().length === 13) {
      return 'Tous les jours'
    }
    if (week.join().length === 11) {
      return 'Tous les jours (sauf dim.)'
    }
    if (week.join().length === 9) {
      return 'Tous les jours (sauf sam./dim.)'
    }
    return ''
  },
  weekToString: week => {
    if (week[0] === '*') {
      return ''
    }
    if (CronUtils.isAllWeek(week)) {
      return CronUtils.stringWeekLength(week)
    }
    const prefix = week.length > 1 ? 'Les ' : 'Le '
    return prefix + week.map(day => moment(day, 'E').format('ddd')).join(', ')
  },
  monthToString(month) {
    if (month[0] == '*') {
      return ''
    }
    return `En ${CronUtils.getDefaultYear()
      .filter(defaultMonth => month.find(selectedMonth => selectedMonth == defaultMonth.month))
      .map(month => month.name)
      .join(', ')}, `
  },
  daysToString: days => {
    if (days[0] == '*') {
      return ''
    }
    const prefix = days.length > 1 ? 'Les ' : 'le '
    return `${
      prefix +
      days
        .map(day => {
          if (day === '1') return '1er'
          return day
        })
        .join(' et ')
    } du mois`
  },
  HoursAndMinutestoString: (hours, minutes) =>
    ` à ${hours.join(`h${moment(minutes, 'm').format('mm')} et `)}h${moment(minutes, 'm').format('mm')}`,
  toSmallText(cron) {
    if (!cron) return ''

    const splitted = CronUtils.parse(cron)

    const month = CronUtils.monthToString(splitted.month)
    const days = CronUtils.daysToString(splitted.days)
    const week = CronUtils.weekToString(splitted.week)

    let hoursAndMinutes = ''

    const hasHours = Array.isArray(splitted.hours) && splitted.hours.length > 0
    const hasMinutes = Array.isArray(splitted.minutes) && splitted.minutes.length > 0

    if (hasHours) {
      hoursAndMinutes = CronUtils.HoursAndMinutestoString(splitted.hours, hasMinutes ? splitted.minutes : ['00'])
    }

    const noMonth = splitted.month[0] === '*'
    const noDays = splitted.days[0] === '*'
    const noWeek = splitted.week[0] === '*'

    // Si tout est générique → Tous les jours
    const fallback = noMonth && noDays && noWeek ? 'Tous les jours ' : ''

    const parts = [month, days, week].filter(Boolean)
    const datePart = parts.length > 0 ? parts.join('') : fallback

    return datePart + hoursAndMinutes
  }
}

export default CronUtils
